import { useRef, useState } from "react";
import { uploadFile, fileUrl, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Upload, X, Loader2, FileCheck2 } from "lucide-react";

// Reusable object-storage upload field. `value` is a storage path (or URL).
export default function UploadField({ value, onChange, kind = "photo", accept, testId }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const isImage = kind === "photo";

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const res = await uploadFile(f, kind);
      onChange(res.path);
      toast.success("Hochgeladen");
    } catch (err) {
      toast.error(apiError(err, "Upload fehlgeschlagen"));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {value ? (
        <div className="flex items-center gap-3">
          {isImage ? (
            <img src={fileUrl(value)} alt="" className="h-16 w-24 rounded-lg border border-border object-cover" />
          ) : (
            <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><FileCheck2 className="h-4 w-4 text-emerald-600" /> Datei hochgeladen</span>
          )}
          <Button variant="ghost" size="sm" className="gap-1.5" onClick={() => onChange("")} data-testid={testId ? `${testId}-remove` : undefined}>
            <X className="h-4 w-4" /> Entfernen
          </Button>
        </div>
      ) : (
        <Button variant="outline" size="sm" className="gap-1.5" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={testId}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Datei wählen
        </Button>
      )}
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={onFile} />
    </div>
  );
}
